import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";

interface RetryMembershipPaymentFailedModalProps {
  paymentMethodLast4?: string | null;
  onClose: () => void;
}

export const RetryMembershipPaymentFailedModal = ({
  paymentMethodLast4,
  onClose,
}: RetryMembershipPaymentFailedModalProps) => {
  return (
    <ActionModal
      size="small"
      open
      onClose={onClose}
      onFirstButtonClick={onClose}
      firstButtonLabel="Manage payment method"
      title="Oh no... we couldn't process your payment"
      description={
        <div className="px-2">
          We were unable to process your payment using your payment method{" "}
          {paymentMethodLast4 && `ending in ${paymentMethodLast4}`}. Please
          update your payment method or retry your current payment method.
        </div>
      }
    />
  );
};
